<template>
  <div>
    <e-dialog
      dialogTitle="选择支付方式"
      :centerDialogVisible="visible"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      :popupWidth="'580px'">
      <div class="dialog-content">
        <div class="margin-b20">
          <span>支付方式：</span>
          <el-radio-group v-model="payType">
            <el-radio :label="2" v-if="info.businessType===1">线下支付并上传凭证</el-radio>
            <el-radio :label="1" v-if="accountStatus">线上支付</el-radio>
          </el-radio-group>
        </div>
        <div v-show="payType===2">
          <div class="margin-b20">确认已向平台支付服务费，并上传支付凭证</div>
          <div>
            <div class="margin-b20">
              <span>上传图片：</span><span style="font-size: 12px;color: #999999">支持JPG、JPEG、PNG格式，不超过5mb，最多可上传3张图片</span>
            </div>
            <el-upload
              :class="['upload', {hidden: fileList.length > 2}]"
              :headers="headers"
              :file-list="fileList"
              :action="fileUploadUrl"
              list-type="picture-card"
              :on-success="handleSuccess"
              :on-error="onError"
              :before-upload="handleBeforeUpload"
              :auto-upload="true"
              :limit="3"
              accept=".jpg,.jpeg,.png">
              <!--              <div slot="tip" style="font-size: 10px;width: 50px;margin-top: -20px;text-align: center">上传图片</div>-->
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.fileUrl" alt="">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="viewFile(file)">
                    <i class="el-icon-view"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="deleteFile(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </div>
        </div>
        <div v-show="payType===1">
          <div>此为收费通知书在线支付，点击确认将创建付款申请至在线支付平台，是否继续付款?</div>
          <div>(点击确认后，请通知贵公司财务人员，以便完成后续付款审核流程。)</div>
        </div>
      </div>
    </e-dialog>
    <viewer-image ref="view" :previewSrcList="previewSrcList" :src="src"/>
  </div>
</template>

<script>
import { epecToken } from '@/modules/projectA/utils/globalData';
import eDialog from '@/components/common/e-dialog';
import viewerImage from '@/modules/projectA/components/common/viewer-image';
import api from '../../api/order';
import userApi from '@/modules/projectA/api/user';

export default {
  name: 'paymentDialog',
  components: { viewerImage, eDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.payType = null;
        this.fileList = [];
        this.src = '';
      }
    }
  },
  created() {
    userApi.batchJudgeOnlinePayment({ companyIdList: [this.$store.state.USERINFO.companyId] }).then((res) => {
      this.accountStatus = res.data[0]?.result?.auth === '已认证';
    });
  },
  data() {
    return {
      payType: null,
      headers: epecToken,
      fileUploadUrl: api.fileUploadForChargeNotice,
      fileList: [],
      src: '',
      accountStatus: false
    };
  },
  computed: {
    previewSrcList() {
      return this.fileList.map(item => item.fileUrl);
    }
  },
  methods: {
    viewFile(file) {
      this.src = file.fileUrl;
      this.$refs.view.show();
    },
    deleteFile(file) {
      this.fileList = this.fileList.filter(item => item.fileUrl !== file.fileUrl);
    },
    resetPopupData() {
      this.$emit('update:visible', false);
    },
    async submitPopupData() {
      if (!this.payType) {
        return this.$message.warning('请选择支付方式');
      }
      if (!this.fileList.length && this.payType === 2) {
        return this.$message.warning('请选择上传支付凭证');
      }
      const params = {};
      if (this.payType === 2) {
        params.chargeNoticeAttachmentList = this.fileList.map(item => {
          return {
            businessType: this.info.businessType,
            chargeNoticeId: this.info.chargeNoticeId,
            chargeNoticeAttachmentId: item.chargeNoticeAttachmentId,
            fileName: item.fileName,
            fileUrl: item.fileUrl
          };
        });
      }
      const res = await api.chargeNoticePayment({
        payerCompanyId: this.$store.state.USERINFO.companyId,
        paymentType: this.payType,
        chargeNoticeId: this.info.chargeNoticeId,
        ...params
      });
      if (res.code === '200') {
        this.$message.success('操作成功');
        this.resetPopupData();
        this.$emit('success');
      }
    },
    onError(err) {
      console.log(err);
    },
    //附件上传成功处理
    handleSuccess(res) {
      if (this.fileList.length === 3) {
        this.$message.warning('最多上传3个附件');
        return;
      }
      if (res.success) {
        this.fileList.push(res.data);
      }
    },
    handleBeforeUpload(file) {
      let size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning('图片不能超过5M');
        return false;
      }
      let fileNameLastIndex = file.name.lastIndexOf('.');
      let fileNameLast = file.name.substring(fileNameLastIndex);
      let fileNameLastArr = ['.jpg', '.png'];
      if (!fileNameLastArr.includes(fileNameLast)) {
        this.$message.warning('只支持jpg、jpeg、png格式图片。');
        return false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
  @import "@/assets/css/theme.scss";

  .dialog-content {
    height: 194px;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
  }
  ::v-deep {
    .el-radio__label {
      font-family: SourceHanSansCN-Regular !important;
      font-weight: normal !important;
    }
  }
  .upload {
    padding-left: 70px;

    &.hidden {
      ::v-deep {
        .el-upload--picture-card {
          display: none;
        }
      }
    }

    ::v-deep {
      .el-upload-list__item.is-uploading,
      .el-upload-list__item.is-ready {
        display: none !important;
      }
      .el-upload-list__item {
        width: 50px;
        height: 50px;
        border-radius: 0;
        border: 1px solid #D9D9D9;
        transition: none !important;
      }

      .el-upload--picture-card {
        width: 50px;
        height: 50px;
        line-height: 1;
        border-radius: 0;

        .el-icon-plus {
          margin-top: 10px;
          font-size: 10px;
          color: $main-col;

          &:after {
            display: block;
            margin-top: 4px;
            content: '上传图片';
            font-size: 10px;
            color: #999999;
          }
        }
      }

      .el-upload-list__item-delete,
      .el-upload-list__item-preview {
        font-size: 14px;
        margin-left: 0;
      }

      .el-upload-list__item-delete {
        margin-left: 6px;
      }
    }
  }
</style>